const showAllFavorites = (button) => {
  /**
   * Animation time
   */
  button.remove();
  let hidden_aparment_cards = document.querySelectorAll('.apartment-card:not(.visible)');
  let visible_apartment_cards = document.querySelectorAll('.apartment-card.visible');
  let last_visible_apartment_card = visible_apartment_cards[visible_apartment_cards.length-1];

  if (hidden_aparment_cards.length) {
    for (var i = hidden_aparment_cards.length - 1; i >= 0; i--) {
      if (typeof hidden_aparment_cards[i].classList !== 'undefined') {
        hidden_aparment_cards[i].style.display = 'block';
        // stagger item animations
        setTimeout(function(item) {
          item.classList.add('visible');
        }, 50 * parseInt(i), hidden_aparment_cards[i]);
      }
    }
  }
  
  last_visible_apartment_card.querySelector('a').focus();
}

window.addEventListener('click', function(e) {
  if (e.target.classList.contains('js-show-all-favorites')) {
    e.preventDefault();
    showAllFavorites(e.target);
  }
});